// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2vwgW","loaderOuter":"PageOverlayLoader_loaderOuter__2DTSM"};